import { useEffect, useCallback } from 'react';
import type { AlgoliaProductAttributes } from '../../AlgoliaProductAttributes';
import { useAnalyticsProvider } from './useAnalyticsProvider';

interface UseSearchTrackingProps {
    query?: string;
    items: AlgoliaProductAttributes[];
    isSearch: boolean;
}

export function useSearchTracking({ query, items, isSearch }: UseSearchTrackingProps) {
    const { trackSearch } = useAnalyticsProvider();

    const trackSearchWithDelay = useCallback((searchTerm: string, itemsFound: number, delay = 300) => {
        setTimeout(() => trackSearch(searchTerm, itemsFound), delay);
    }, [trackSearch]);

    useEffect(() => {
        if (typeof window === 'undefined') return;
        if (!isSearch || !query || query.trim().length === 0) {
            return;
        }

        trackSearchWithDelay(query.trim(), items.length);
    }, [items, query, isSearch, trackSearchWithDelay]);

    return {
        trackSearch,
        trackSearchWithDelay
    };
}